module.exports = __webpack_public_path__ + "img/resume-create.1999fe27.svg";